var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.837,
    height: 28.385,
    viewBox: "0 0 24.837 28.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-day",
    "data-name": "Icon awesome-calendar-day",
    d: "M0,25.724a2.662,2.662,0,0,0,2.661,2.661H22.176a2.662,2.662,0,0,0,2.661-2.661V10.644H0ZM3.548,15.079a.89.89,0,0,1,.887-.887H9.757a.89.89,0,0,1,.887.887V20.4a.89.89,0,0,1-.887.887H4.435a.89.89,0,0,1-.887-.887ZM22.176,3.548H19.515V.887A.89.89,0,0,0,18.628,0H16.853a.89.89,0,0,0-.887.887V3.548H8.87V.887A.89.89,0,0,0,7.983,0H6.209a.89.89,0,0,0-.887.887V3.548H2.661A2.662,2.662,0,0,0,0,6.209V8.87H24.837V6.209A2.662,2.662,0,0,0,22.176,3.548Z",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.cb19e9ad8da6e92749ff7a8593fb2f4d.svg";
export { ForwardRef as ReactComponent };